var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import PurchaseOrderForUpperSupService from '../../../api/PurchaseOrderForUpperSupService';
import EHanldeStatus from '../../../enum/EHandleStatus';
import { getDateAtZeroPoint } from '../../../helper/dateUtil';
import HeaderItem from "../../../components/HeaderItem";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eHanldeStatus = EHanldeStatus;
        _this.accountOptions = [];
        _this.accountNameOptions = [];
        _this.accountPhoneOptions = [];
        _this.supplierupperOptions = [];
        _this.supplierorganOptions = [];
        _this.supplierdepotOptions = [];
        _this.deliveryTypeOptions = [
            {
                id: 1,
                name: '配送'
            }
        ];
        _this.otherFormData = {
            delivery_type: 1,
        };
        _this.orderDatePickerOptions = {
            disabledDate: function (time) {
                return false;
            }
        };
        _this.arrivedDatePickerOptions = {
            disabledDate: function (time) {
                return false;
            }
        };
        return _this;
    }
    default_1.prototype.watchpurchase_time = function (newValue, oldValue) {
        this.arrivedDatePickerOptions = {
            disabledDate: function (time) {
                if (newValue) {
                    var start = getDateAtZeroPoint(new Date(newValue));
                    return time.getTime() < start.getTime();
                }
                else {
                    return false;
                }
            }
        };
    };
    default_1.prototype.watchorder_arriveddate = function (newValue, oldValue) {
        this.orderDatePickerOptions = {
            disabledDate: function (time) {
                if (newValue) {
                    var end = getDateAtZeroPoint(new Date(newValue));
                    return time.getTime() > end.getTime();
                }
                else {
                    return false;
                }
            }
        };
    };
    default_1.prototype.watchFormDataSupplierUpperId = function (newVal, oldVal) {
        if (this.handleStatus === EHanldeStatus.Edit) {
            return;
        }
        if (newVal) {
            if (oldVal) {
                this.formData.organ_id = '';
                this.$emit('emptyGood');
            }
            this.getSupplierorganOptions();
        }
        else {
            this.supplierorganOptions = [];
            this.formData.organ_id = '';
        }
    };
    default_1.prototype.watchFormDataOrganId = function (newVal, oldVal) {
        if (this.handleStatus === EHanldeStatus.Edit) {
            return;
        }
        if (newVal) {
            if (oldVal) {
                this.formData.depot_id = '';
                this.formData.purchaser_name = '';
                this.formData.purchaser_phone = '';
                this.$emit('emptyGood');
            }
            this.getSupplierdepotOptions();
        }
        else {
            this.supplierdepotOptions = [];
            this.formData.depot_id = '';
            this.formData.purchaser_name = '';
            this.formData.purchaser_phone = '';
        }
    };
    default_1.prototype.watchDepotId = function (newVal, oldVal) {
        if (this.handleStatus === EHanldeStatus.Edit) {
            return;
        }
        if (newVal) {
            var newdepotName = this.supplierdepotOptions.filter(function (item) { return item.depot_id == newVal; });
            this.formData.concat_address = newdepotName[0].depot_address;
        }
    };
    default_1.prototype.created = function () {
        this.service = PurchaseOrderForUpperSupService.getInstance();
        this.getSupplierupperOptions();
        this.getAccountOptions();
    };
    default_1.prototype.mounted = function () { };
    default_1.prototype.depotSelect = function (value) {
        var currentDepot = this.supplierdepotOptions.find(function (item) { return item.depot_id === value; });
        this.formData.purchaser_name = currentDepot.depot_contact;
        this.formData.purchaser_phone = currentDepot.depot_phone;
    };
    default_1.prototype.querySearchName = function (queryString, cb) {
        var accountNameOptions = this.accountNameOptions;
        var nameResults = queryString ? accountNameOptions.filter(this.createFilter(queryString)) : accountNameOptions;
        cb(nameResults);
    };
    default_1.prototype.querySearchPhone = function (queryString, cb) {
        var accountPhoneOptions = this.accountPhoneOptions;
        var phoneResults = queryString ? accountPhoneOptions.filter(this.createFilter(queryString)) : accountPhoneOptions;
        cb(phoneResults);
    };
    default_1.prototype.createFilter = function (queryString) {
        return function (result) {
            return (result.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
    };
    default_1.prototype.fillPhone = function (item) {
        this.formData.purchaser_phone = item.mobile;
    };
    default_1.prototype.fillName = function (item) {
        this.formData.purchaser_name = item.name;
    };
    default_1.prototype.getSupplierupperOptions = function (val) {
        var _this = this;
        var params = {
            keyword: val || ''
        };
        this.service.getSupplierupperOptions(params).then(function (res) {
            if (res.data.success) {
                _this.supplierupperOptions = res.data.data;
            }
        });
    };
    default_1.prototype.getSupplierorganOptions = function () {
        var _this = this;
        this.service.getSupplierorganOptions({
            supplier_upper_id: this.formData.supplier_upper_id
        }).then(function (res) {
            if (res.data.success) {
                _this.supplierorganOptions = res.data.data;
                _this.formData.organ_id = res.data.data && res.data.data[0].organ_id || '';
            }
        });
    };
    default_1.prototype.getSupplierdepotOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id,
            is_init: 1
        };
        this.service.getSupplierdepotOptions(params).then(function (res) {
            if (res.data.success) {
                _this.supplierdepotOptions = res.data.data;
                (res.data.data || []).some(function (item) {
                    if (item.is_organ_default == 1) {
                        _this.formData.depot_id = item.depot_id;
                        _this.formData.purchaser_name = item.depot_contact;
                        _this.formData.purchaser_phone = item.depot_phone;
                        if (_this.handleStatus === _this.eHanldeStatus.Add) {
                            _this.formData.concat_address = item.depot_address;
                        }
                        return true;
                    }
                    _this.formData.depot_id = '';
                    _this.formData.purchaser_name = '';
                    _this.formData.purchaser_phone = '';
                });
            }
        });
    };
    default_1.prototype.getAccountOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id
        };
        this.service.getAccountOptions().then(function (res) {
            if (res.data.success) {
                _this.accountOptions = res.data.data;
                _this.accountNameOptions = JSON.parse(JSON.stringify(res.data.data));
                _this.accountPhoneOptions = JSON.parse(JSON.stringify(res.data.data));
                _this.accountNameOptions = _this.accountNameOptions.map(function (item) {
                    return {
                        value: item.name,
                        mobile: item.mobile
                    };
                });
                _this.accountPhoneOptions = _this.accountPhoneOptions.map(function (item) {
                    return {
                        value: item.mobile,
                        name: item.name,
                    };
                });
            }
        });
    };
    default_1.prototype.filterSearch = function (val) {
        var _this = this;
        var This = this;
        clearTimeout(this.time);
        this.time = setTimeout(function () {
            _this.getSupplierupperOptions(val);
        }, 500);
    };
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Watch("formData.purchase_time", { immediate: true })
    ], default_1.prototype, "watchpurchase_time", null);
    __decorate([
        Watch("formData.order_arriveddate", { immediate: true })
    ], default_1.prototype, "watchorder_arriveddate", null);
    __decorate([
        Watch('formData.supplier_upper_id')
    ], default_1.prototype, "watchFormDataSupplierUpperId", null);
    __decorate([
        Watch('formData.organ_id')
    ], default_1.prototype, "watchFormDataOrganId", null);
    __decorate([
        Watch('formData.depot_id')
    ], default_1.prototype, "watchDepotId", null);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
